import computeClassName from '../../../../../../../utils/computeClassName';

export default function CCIconSocialYouTube20x20({ className }) {
  const computedClassName = computeClassName(className, '');
  return (
    <svg className={computedClassName} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2682_52)">
        <path d="M19.5818 5.2C19.4687 4.77451 19.2459 4.38618 18.9356 4.07388C18.6253 3.76158 18.2384 3.53625 17.8136 3.42045C16.25 3 10 3 10 3C10 3 3.75 3 2.18636 3.42045C1.76161 3.53625 1.37472 3.76158 1.06441 4.07388C0.754097 4.38618 0.531255 4.77451 0.418182 5.2C0 6.77045 0 10.0455 0 10.0455C0 10.0455 0 13.3205 0.418182 14.8909C0.531255 15.3164 0.754097 15.7047 1.06441 16.017C1.37472 16.3293 1.76161 16.5547 2.18636 16.6705C3.75 17.0909 10 17.0909 10 17.0909C10 17.0909 16.25 17.0909 17.8136 16.6705C18.2384 16.5547 18.6253 16.3293 18.9356 16.017C19.2459 15.7047 19.4687 15.3164 19.5818 14.8909C20 13.3205 20 10.0455 20 10.0455C20 10.0455 20 6.77045 19.5818 5.2Z" fill="#939595"/>
        <path d="M7.95459 13.0193L13.1819 10.0454L7.95459 7.07153V13.0193Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_2682_52">
          <rect width="20" height="14.0909" fill="white" transform="translate(0 3)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

